//定义相关组件
const viewsPage = () => import('@/views/app/ViewsPage')
const login = () => import('@/views/app/Login')
const forgotPwdOne = () => import('@/views/app/ForgotPwdOne')
const forgotPwdTwo = () => import('@/views/app/ForgotPwdTwo')
const notFound = () => import('@/views/app/404')
const changePwd = () => import('@/views/app/ChangePwd')
const userCenter = () => import('@/views/system/mine')
const userInfo = () => import('@/views/my/UserInfo')
const practice = () => import('@/views/my/practice')
const productList = () => import('@/views/product/ProductList')
const productDetail = () => import('@/views/product/ProductDetail')
const productDetail_type1 = () => import('@/views/product/ProductDetail_type1')
const productDetail_type_xueping = () => import('@/views/product/ProductDetail_type_xueping')
const productDetail_type_accident = () => import('@/views/product/ProductDetail_type_accident')
const product_team_info = () => import('@/views/product/Product_team_info')
const product_team_detail = () => import('@/views/product/Product_team_detail')
const product_result = () => import('@/views/product/Product_result')
const product_xueping_detail = () => import('@/views/product/Product_xueping_detail')
const product_xueping_info = () => import('@/views/product/Product_xueping_info')
const product_teyaoka_info = () => import('@/views/product/Product_teyaoka_info')
const product_teyaoka_detail = () => import('@/views/product/Product_teyaoka_detail')
const product_zscp_info = () => import('@/views/product/Product_zscp_info')
const product_zscp_detail = () => import('@/views/product/Product_zscp_detail')
const product_pajc_info = () => import('@/views/product/Product_pajc_info')
const product_pajc_detail = () => import('@/views/product/Product_pajc_detail')

const product_ensure_detail = () => import('@/views/product/Product_ensure_detail')

const serveList = () => import('@/views/serve/List')
const serveDetail = () => import('@/views/serve/Detail')
const customerList = () => import('@/views/customer/CustomerList')
const customerInfo = () => import('@/views/customer/CustomerInfo')
const editCustomer = () => import('@/views/customer/EditCustomer')
const addCustomer = () => import('@/views/customer/AddCustomer')
const policyList = () => import('@/views/serve/PolicyList')
const insuredInfo = () => import('@/views/sale/InsuredInfo')
const insuredInfo_xueping = () => import('@/views/sale-xueping/InsuredInfo')
const insuredInfo_accident = () => import('@/views/sale-accident/InsuredInfo')
const saleInsuredPerson = () => import('@/views/sale/InsuredPerson')
const saleInsuredPerson_xueping = () => import('@/views/sale-xueping/InsuredPerson')
const saleInsuredPerson_accident = () => import('@/views/sale-accident/InsuredPerson')
const calculatePremiumEdit = () => import('@/views/sale/CalculatePremiumEdit')
const calculatePremiumEdit_type1 = () => import('@/views/sale/CalculatePremiumEdit_type1')
const calculatePremiumEdit_type_xueping = () => import('@/views/sale/CalculatePremiumEdit_type1')

const beneficiary = () => import('@/views/sale/Beneficiary')
const beneficiary_accident = () => import('@/views/sale-accident/Beneficiary')
const notifyingMessage = () => import('@/views/sale/NotifyingMessage')
const notifyingMessage_xueping = () => import('@/views/sale-xueping/NotifyingMessage')
const notifyingMessage_accident = () => import('@/views/sale-accident/NotifyingMessage')
const accountInformation = () => import('@/views/sale/AccountInformation')
const attachmentManagement = () => import('@/views/sale/AttachmentManagement')
const signatureConfirmation = () => import('@/views/sale/SignatureConfirmation')
const insuranceInformation = () => import('@/views/sale/InsuranceInformation')
const insuranceInformation_xueping = () => import('@/views/sale-xueping/InsuranceInformation')
const insuranceInformation_accident = () => import('@/views/sale-accident/InsuranceInformation')
const signatureOfElectronic = () => import('@/views/sale/SignatureOfElectronic')
const specificationAdd = () => import('@/views/sale/SpecificationAdd')
const specificationMain = () => import('@/views/sale/SpecificationMain')
const payResult = () => import('@/views/sale/PayResult')
const payResult1 = () => import('@/views/sale/PayResult1')
const payMent = () => import('@/views/sale/PayMent')
const result = () => import('@/views/sale/Result')
const insuredList = () => import('@/views/sale/InsuredList')
const ConfirmationInformation_xueping = () => import('@/views/sale-xueping/ConfirmationInformation')
const ConfirmationInformation_accident = () => import('@/views/sale-accident/ConfirmationInformation')

const proposalList = () => import('@/views/proposal/ProposalList')
const appnt = () => import('@/views/proposal/Appnt')
const chooseInsuredPerson = () => import('@/views/proposal/ChooseInsuredPerson')
const insuredPerson = () => import('@/views/proposal/InsuredPerson')
const selectedProduct = () => import('@/views/proposal/SelectedProduct')
const mainRiskList = () => import('@/views/proposal/MainRiskList')
// const calculatePremium = () => import('@/views/common/CalculatePremium')
const calculatePremium = () => import('@/views/proposal/CalculatePremium')
const exhibition = () => import('@/views/proposal/Exhibition')
const exhibitionWX = () => import('@/views/proposal/ExhibitionWX')
const companyProfile = () => import('@/views/proposal/CompanyProfile')
const pdf = () => import('@/views/proposal/PDF')

const pdfComponent = () => import('@/views/sale/PdfH5')
const saleList = () => import('@/views/sale/List')
const saleDetail = () => import('@/views/sale/Detail')
const saleGroupDetail = () => import('@/views/sale/GroupDetail')
const groupDetailConfirm = () => import('@/views/sale/GroupDetailConfirm')

const addBeneficiaryInfo = () => import('@/views/sale/AddBeneficiaryInfo')
const home = () => import('@/views/app/Home')

const selfEntryRegister = () => import('@/views/selfEntry/selfEntryRegister')
const selfEntryType = () => import('@/views/selfEntry/selfEntryType')
const selfEntryInfo = () => import('@/views/selfEntry/selfEntryInfo')
const selfEntryUpload = () => import('@/views/selfEntry/selfEntryUpload')
const selfEntryerror = () => import('@/views/selfEntry/selfEntryerror')
const realNameSuccess = () => import('@/views/selfEntry/realNameSuccess')
const systemPdf = () => import('@/views/system/pdf')
const businessCardWX = () => import('@/views/businessCard/BusinessCardWX')

const withdrawal = () => import('@/views/other/withdrawal')
const originLink = () => import('@/views/other/originLink')
const oss = () => import('@/views/other/oss')

const settlementAmountList = () => import('@/views/system/settlementAmountList')
const settlementAmountDetail = () => import('@/views/system/settlementAmountDetail')
const outstandingList = () => import('@/views/system/outstandingList')
const outstandingDetail = () => import('@/views/system/outstandingDetail')
const increaseSuccess = () => import('@/views/increase/increaseSuccess')
const perfectInfo = () => import('@/views/system/perfectInfo')

const trainList = () => import('@/views/train/List')
const trainDetail = () => import('@/views/train/Detail')
const trainSearch = () => import('@/views/train/Search')

const renewalList = () => import('@/views/renewal/renewalList')
const renewalDetail = () => import('@/views/renewal/renewalDetail')

const renewalPolicyQueryList = () => import('@/views/renewal/renewalPolicyQueryList')
const queryRenewRecordDetail = () => import('@/views/renewal/queryRenewRecordDetail')
const visitor = () => import('@/views/visitor/list')
const activeIndex = () => import('@/views/active/index')
const activeSearch = () => import('@/views/active/Search')
const activeDetail = () => import('@/views/active/detail')

import Example from '../example/index.js'
let allComponents = [
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: {
      title: '首页',
      index: 1,
      auth: true,
    },
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: changePwd,
    meta: {
      title: '修改密码',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    component: userCenter,
    meta: {
      title: '我的',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: userInfo,
    meta: {
      title: '代理人基本信息',
      index: 3,
      backPath: '/userCenter',
      auth: true,
    },
  },
  {
    path: '/practice',
    name: 'practice',
    component: practice,
    meta: {
      title: '执业认证',
      index: 3,
      backPath: '/userCenter',
      auth: true,
    },
  },
  // =====================================================
  {
    path: '/renewalList',
    name: 'renewalList',
    component: renewalList,
    meta: {
      title: '续期查询',
      index: 3,
      backPath: '/userCenter',
      // auth: true
    },
  },
  {
    path: '/renewalDetail',
    name: 'renewalDetail',
    component: renewalDetail,
    meta: {
      title: '续期查询',
      index: 3,
      backPath: '/renewalList',
      // auth: true
    },
  },
  {
    path: '/renewalPolicyQueryList',
    name: 'renewalPolicyQueryList',
    component: renewalPolicyQueryList,
    meta: {
      title: '续保查询',
      index: 3,
      backPath: '/userCenter',
      // auth: true
    },
  },
  {
    path: '/queryRenewRecordDetail',
    name: 'queryRenewRecordDetail',
    component: queryRenewRecordDetail,
    meta: {
      title: '续保查询',
      index: 3,
      backPath: '/renewalPolicyQueryList',
      // auth: true
    },
  },
  {
    path: '/visitor',
    name: 'visitor',
    component: visitor,
    meta: {
      title: '我的访客',
      index: 3,
      backPath: '/visitor',
      // auth: true
    },
  },
  {
    path: '/activeIndex',
    name: 'activeIndex',
    component: activeIndex,
    meta: {
      title: '活动管理',

      auth: true,
    },
  },
  {
    path: '/activeSearch',
    name: 'activeSearch',
    component: activeSearch,
    meta: {
      title: '活动搜索',

      auth: true,
    },
  },
  {
    path: '/activeDetail',
    name: 'activeDetail',
    component: activeDetail,
    meta: {
      title: '活动详情',

      auth: true,
    },
  },
  // ========================================================
  {
    path: '/perfectInfo',
    name: 'perfectInfo',
    component: perfectInfo,
    meta: {
      title: '完善信息',
      index: 3,
      backPath: '/userCenter',
      auth: true,
    },
  },
  {
    path: '/productList',
    name: 'productList',
    component: productList,
    meta: {
      title: '产品',
      index: 2,
      auth: true,
      keepAlive: true,
    },
  },
  {
    path: '/productDetail/:productDetailCode',
    name: 'productDetail',
    component: productDetail,
    meta: {
      title: '产品详情',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/productDetail_type1/:productDetailCode',
    name: 'productDetail_type1',
    component: productDetail_type1,
    meta: {
      title: '产品详情',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/productDetail_type_xueping/:productDetailCode',
    name: 'productDetail_type_xueping',
    component: productDetail_type_xueping,
    meta: {
      title: '产品详情',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/productDetail_type_accident/:productDetailCode',
    name: 'productDetail_type_accident',
    component: productDetail_type_accident,
    meta: {
      title: '产品详情',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_team_info/:productDetailCode',
    name: 'product_team_info',
    component: product_team_info,
    meta: {
      title: '产品介绍',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_xueping_info/:productDetailCode',
    name: 'product_xueping_info',
    component: product_xueping_info,
    meta: {
      title: '产品介绍',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_teyaoka_info/:productDetailCode',
    name: 'product_teyaoka_info',
    component: product_teyaoka_info,
    meta: {
      title: '产品介绍',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_zscp_info/:productDetailCode',
    name: 'product_zscp_info',
    component: product_zscp_info,
    meta: {
      title: '产品介绍',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_pajc_info/:productDetailCode',
    name: 'product_pajc_info',
    component: product_pajc_info,
    meta: {
      title: '产品介绍',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_team_detail/:productDetailCode',
    name: 'product_team_detail',
    component: product_team_detail,
    meta: {
      title: '信息录入',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_xueping_detail/:productDetailCode',
    name: 'product_xueping_detail',
    component: product_xueping_detail,
    meta: {
      title: '信息录入',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_ensure_detail/:productDetailCode',
    name: 'product_ensure_detail',
    component: product_ensure_detail,
    meta: {
      title: '信息录入',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_teyaoka_detail/:productDetailCode',
    name: 'product_teyaoka_detail',
    component: product_teyaoka_detail,
    meta: {
      title: '信息录入',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_zscp_detail/:productDetailCode',
    name: 'product_zscp_detail',
    component: product_zscp_detail,
    meta: {
      title: '信息录入',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_pajc_detail/:productDetailCode',
    name: 'product_pajc_detail',
    component: product_pajc_detail,
    meta: {
      title: '信息录入',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/product_result',
    name: 'product_result',
    component: product_result,
    meta: {
      title: '提交结果',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/customerList',
    name: 'customerList',
    component: customerList,
    meta: {
      title: '客户列表',
      // index: 3,
      auth: true,
    },
  },
  {
    path: '/customerInfo',
    name: 'customerInfo',
    component: customerInfo,
    meta: {
      title: '客户详情',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/editCustomer',
    name: 'editCustomer',
    component: editCustomer,
    meta: {
      title: '编辑客户信息',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/addCustomer',
    name: 'addCustomer',
    component: addCustomer,
    meta: {
      title: '新增客户信息',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/serveList',
    name: 'serveList',
    component: serveList,
    meta: {
      title: '保单列表',
      // index: 3,
      auth: true,
    },
  },
  {
    path: '/serveDetail',
    name: 'serveDetail',
    component: serveDetail,
    meta: {
      title: '保单详情',
      index: 3,
      backPath: '/serveList',
    },
  },
  {
    path: '/policyList',
    name: 'policyList',
    component: policyList,
    meta: {
      title: '客户保单列表',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/proposalList',
    name: 'proposalList',
    component: proposalList,
    meta: {
      title: '计划书列表',
      // index: 3,
      auth: true,
    },
  },
  {
    path: '/appnt',
    name: 'appnt',
    component: appnt,
    meta: {
      title: '投保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/chooseInsuredPerson',
    name: 'chooseInsuredPerson',
    component: chooseInsuredPerson,
    meta: {
      title: '选择被保人',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/insuredPerson',
    name: 'insuredPerson',
    component: insuredPerson,
    meta: {
      title: '被保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/selectedProduct',
    name: 'selectedProduct',
    component: selectedProduct,
    meta: {
      title: '产品列表',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/mainRiskList',
    name: 'mainRiskList',
    component: mainRiskList,
    meta: {
      title: '主险列表',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/calculatePremium',
    name: 'calculatePremium',
    component: calculatePremium,
    meta: {
      title: '保费计算',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/exhibition',
    name: 'exhibition',
    component: exhibition,
    meta: {
      title: '计划书演示',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/exhibitionWX',
    name: 'exhibitionWX',
    component: exhibitionWX,
    meta: {
      title: '计划书演示',
      // index: 2,
      // auth: false,
    },
  },
  {
    path: '/companyProfile',
    name: 'companyProfile',
    component: companyProfile,
    meta: {
      title: '公司简介',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: pdf,
    meta: {
      title: 'PDF预览',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/pdfComponent',
    name: 'pdfComponent',
    component: pdfComponent,
    meta: {
      title: 'PDF阅读',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuredInfo',
    name: 'insuredInfo',
    component: insuredInfo,
    meta: {
      title: '投保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuredInfo_xueping',
    name: 'insuredInfo',
    component: insuredInfo_xueping,
    meta: {
      title: '投保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuredInfo_accident',
    name: 'insuredInfo',
    component: insuredInfo_accident,
    meta: {
      title: '投保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuredPerson',
    name: 'insuredPerson',
    component: saleInsuredPerson,
    meta: {
      title: '被保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuredPerson_xueping',
    name: 'insuredPerson',
    component: saleInsuredPerson_xueping,
    meta: {
      title: '被保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuredPerson_accident',
    name: 'insuredPerson',
    component: saleInsuredPerson_accident,
    meta: {
      title: '被保人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/calculatePremiumEdit',
    name: 'calculatePremiumEdit',
    component: calculatePremiumEdit,
    meta: {
      title: '保费计算',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/calculatePremiumEdit_type1',
    name: 'calculatePremiumEdit_type1',
    component: calculatePremiumEdit_type1,
    meta: {
      title: '保费计算',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/calculatePremiumEdit_type_xueping',
    name: 'calculatePremiumEdit_type_xueping',
    component: calculatePremiumEdit_type_xueping,
    meta: {
      title: '保费计算',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/beneficiary',
    name: 'beneficiary',
    component: beneficiary,
    meta: {
      title: '受益人',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/beneficiary_accident',
    name: 'beneficiary_accident',
    component: beneficiary_accident,
    meta: {
      title: '受益人',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/addBeneficiaryInfo',
    name: 'addBeneficiaryInfo',
    component: addBeneficiaryInfo,
    meta: {
      title: '指定受益人信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/notifyingMessage',
    name: 'notifyingMessage',
    component: notifyingMessage,
    meta: {
      title: '告知信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/notifyingMessage_xueping',
    name: 'notifyingMessage_xueping',
    component: notifyingMessage_xueping,
    meta: {
      title: '告知信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/notifyingMessage_accident',
    name: 'notifyingMessage_accident',
    component: notifyingMessage_accident,
    meta: {
      title: '告知信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/accountInformation',
    name: 'accountInformation',
    component: accountInformation,
    meta: {
      title: '账户信息',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/attachmentManagement',
    name: 'attachmentManagement',
    component: attachmentManagement,
    meta: {
      title: '附件管理',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/signatureConfirmation',
    name: 'signatureConfirmation',
    component: signatureConfirmation,
    meta: {
      title: '签名确认',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuranceInformation',
    name: 'insuranceInformation',
    component: insuranceInformation,
    meta: {
      title: '投保提示',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuranceInformation_xueping',
    name: 'insuranceInformation_xueping',
    component: insuranceInformation_xueping,
    meta: {
      title: '投保提示',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/insuranceInformation_accident',
    name: 'insuranceInformation_accident',
    component: insuranceInformation_accident,
    meta: {
      title: '投保提示',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/ConfirmationInformation_xueping',
    name: 'ConfirmationInformation_xueping',
    component: ConfirmationInformation_xueping,
    meta: {
      title: '投保确认',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/ConfirmationInformation_accident',
    name: 'ConfirmationInformation_accident',
    component: ConfirmationInformation_accident,
    meta: {
      title: '投保确认',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/signatureOfElectronic',
    name: 'signatureOfElectronic',
    component: signatureOfElectronic,
    meta: {
      title: '订单签名',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/specificationAdd',
    name: 'specificationAdd',
    component: specificationAdd,
    meta: {
      title: '产品说明书',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/specificationMain',
    name: 'specificationMain',
    component: specificationMain,
    meta: {
      title: '产品说明书',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/pdfComponent',
    name: 'pdfComponent',
    component: pdfComponent,
    meta: {
      title: '详情阅读',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/payResult',
    name: 'payResult',
    component: payResult,
    meta: {
      title: '支付结果',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/payResult1',
    name: 'payResult1',
    component: payResult1,
    meta: {
      title: '支付结果',
      index: 2,
      auth: true,
      isSingle: 1,
    },
  },
  {
    path: '/sale/payMent',
    name: 'payMent',
    component: payMent,
    meta: {
      title: '支付',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/result',
    name: 'result',
    component: result,
    meta: {
      title: '核保结果',
      index: 2,
      auth: true,
    },
  },
  {
    path: '/sale/list',
    name: 'saleList',
    component: saleList,
    meta: {
      title: '订单列表',
      // index: 3,
      auth: true,
    },
  },
  {
    path: '/sale/detail',
    name: 'saleDetail',
    component: saleDetail,
    meta: {
      title: '订单详情',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/sale/groupdetail',
    name: 'saleGroupDetail',
    component: saleGroupDetail,
    meta: {
      title: '团险订单详情',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/sale/groupDetailConfirm',
    name: 'groupDetailConfirm',
    component: groupDetailConfirm,
    meta: {
      title: '团险订单确认',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/settlementAmountList',
    name: 'settlementAmountList',
    component: settlementAmountList,
    meta: {
      title: '已结算',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/settlementAmountDetail',
    name: 'settlementAmountDetail',
    component: settlementAmountDetail,
    meta: {
      title: '已结算',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/outstandingList',
    name: 'outstandingList',
    component: outstandingList,
    meta: {
      title: '未结算',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/outstandingDetail',
    name: 'outstandingDetail',
    component: outstandingDetail,
    meta: {
      title: '未结算',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/sale/insuredList',
    name: 'saleInsuredList',
    component: insuredList,
    meta: {
      title: '被保人列表',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/trainList',
    name: 'trainList',
    component: trainList,
    meta: {
      title: '培训课堂',
      // index: 1,
      auth: true,
    },
  },
  {
    path: '/trainDetail',
    name: 'trainDetail',
    component: trainDetail,
    meta: {
      title: '培训详情',
      // index: 1,
      auth: true,
    },
  },
  {
    path: '/trainSearch',
    name: 'trainSearch',
    component: trainSearch,
    meta: {
      title: '搜索',
      // index: 1,
      auth: true,
    },
  },

  {
    path: '/oss',
    name: 'oss',
    component: oss,
    meta: {
      title: 'oss',
      index: 3,
      auth: true,
    },
  },
  {
    path: '/404',
    component: notFound,
    meta: {
      title: '404',
      auth: false,
    },
  },
]
export default [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '登录页',
      auth: false,
    },
  },
  {
    path: '/forgotPwdOne',
    name: 'forgotPwdOne',
    component: forgotPwdOne,
    meta: {
      title: '忘记密码',
      auth: false,
    },
  },
  {
    path: '/forgotPwdTwo',
    name: 'forgotPwdTwo',
    component: forgotPwdTwo,
    meta: {
      title: '忘记密码',
      auth: false,
    },
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/ebiz',
    name: 'ebiz',
    component: viewsPage,
    children: [...allComponents, ...Example],
  },
  {
    path: '/selfEntryRegister',
    name: 'selfEntryRegister',
    component: selfEntryRegister,
    meta: {
      title: '加入我们',
    },
  },
  {
    path: '/increaseSuccess',
    name: 'increaseSuccess',
    component: increaseSuccess,
    meta: {
      title: '注册成功',
    },
  },
  {
    path: '/selfEntryerror',
    name: 'selfEntryerror',
    component: selfEntryerror,
    meta: {
      title: '自助入司',
      index: 1,
    },
  },
  {
    path: '/realNameSuccess',
    name: 'realNameSuccess',
    component: realNameSuccess,
    meta: {
      title: '提交成功',
      index: 1,
    },
  },
  {
    path: '/selfEntryType',
    name: 'selfEntryType',
    component: selfEntryType,
    meta: {
      title: '自助入司',
      index: 1,
    },
  },
  {
    path: '/selfEntryInfo',
    name: 'selfEntryInfo',
    component: selfEntryInfo,
    meta: {
      title: '实名认证',
      index: 1,
    },
  },
  {
    path: '/selfEntryUpload',
    name: 'selfEntryUpload',
    component: selfEntryUpload,
    meta: {
      title: '自助入司',
      index: 1,
    },
  },
  {
    path: '/system/pdf',
    name: 'systemPdf',
    component: systemPdf,
    meta: {
      title: '系统设置',
    },
  },
  {
    path: '/businessCardWX',
    name: 'businessCardWX',
    component: businessCardWX,
    meta: {
      title: '分享名片',
      auth: false,
    },
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: withdrawal,
    meta: {
      title: '提现',
      auth: false,
    },
  },
  {
    path: '/originLink',
    name: 'originLink',
    component: originLink,
    meta: {
      title: '',
      auth: false,
    },
  },
]
